import styled from "styled-components";

export const Container = styled.section``;

export const Header = styled.div`
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin: 0 0 30px 0;

  .add-address-btn {
    border: none;
    background: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #253d4e;
    & span {
      transition: all 0.1s;
    }
    :hover {
      color: #3bb77e;
    }
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  @media (max-width: 1025px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const AddressBox = styled.div`
  position: relative;
  background-color: #fff;
  border: 1px solid #ececec;
  border-radius: 15px;
  overflow: hidden;
  transition: 0.2s;
  -moz-transition: 0.2s;
  -webkit-transition: 0.2s;
  -o-transition: 0.2s;
  margin-bottom: 0.7rem;
  margin-right: 0.7rem;
  width: 100%;
  cursor: pointer;
  :hover {
    -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
    border: 1px solid #bce3c9;
    transition: 0.2s;
    -moz-transition: 0.2s;
    -webkit-transition: 0.2s;
    -o-transition: 0.2s;
  }

  .product-badges.product-badges-position {
    position: absolute;
    right: 0;
    top: 0px;
    z-index: 9;
    > span {
      display: inline-block;
      font-size: 12px;
      line-height: 1;
      border-radius: 0px 10px 0 20px;
      color: #fff;
      padding: 9px 20px 10px 20px;
      background-color: #f74b81;
    }
  }
`;

export const AddressContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 30px 20px;

  .address-info {
    font-size: 14px;
    color: #253d4e;

    & li:not(:last-child) {
      margin-bottom: 4px;
      img {
        margin-right: 8px;
        max-width: 16px;
      }
    }
  }
  .basic-btns {
    display: flex;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .address-btn {
    display: flex;
    margin-top: 1rem;
    justify-content: space-between;
    flex-wrap: wrap;

    .select-btns {
      display: flex;
      margin-right: 10px;
      margin-bottom: 10px;
    }

    & button {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 3.2rem;
      font-size: 14px;
      font-weight: 400;
      padding: 5px 20px;
      border-radius: 5px;
      word-break: keep-all;
      background-color: #fff;
      color: #253d4e;
      border: 1px solid #253d4e;
      :hover {
        background-color: #253d4e;
        color: #fff;
      }
    }

    .btn-select {
      border: none;
      background-color: #3bb77e;
      color: #fff;
      :hover {
        background-color: #fd7e14;
      }
    }

    .btn-select-basic {
      border: none;
      background-color: #3bb77e;
      color: #fff;
      padding: 0 10px;
      margin: 0;
      :hover {
        background-color: #f1c40f;
      }
    }

    & button:not(:last-of-type) {
      margin-right: 10px;
    }
  }
`;
